import { render, staticRenderFns } from "./NewDAddressEditor.vue?vue&type=template&id=a50158b6&"
import script from "./NewDAddressEditor.vue?vue&type=script&lang=js&"
export * from "./NewDAddressEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewDAddressEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports